import { z } from 'zod';
import { emailValidator } from '../../utils/common';
export const RequestPasswordChangeSchema = z
    .object({ email: emailValidator })
    .describe('Request Password Change object with email');
//# sourceMappingURL=requestPasswordChangeSchema.js.map